export const maxWidth = 1184;
// export const gradientColor1 = "#EE9B77"; // Peach
// export const gradientColor2 = "#F54AD6"; // Purple
export const gradientColor1 = "#15CA7B"; // Green
export const gradientColor2 = "#4C9DDC"; // Blue
